import React from "react";
import { default as MUICard } from "@mui/material/Card";


export const Card = (props) => {
  return <MUICard {...props} />;
};
